/* eslint-disable react/jsx-filename-extension */

import React from 'react';
import ReactDOM from 'react-dom';

import StatsService from '../../services/StatsService';
import Stats from './Stats';

(async () => {
    window.stats = await StatsService.get();

    const statsContainers = document.querySelectorAll('[data-stats]');
    [...statsContainers].forEach((statsContainer) => {
        ReactDOM.render(
            <Stats {...statsContainer.dataset} />,
            statsContainer,
        );
    });
})();
